import React from 'react';
import buildsEnhancedMarkdownOverrides from '@resources/js/helpers/buildsEnhancedMarkdownOverrides';
import EnhancedMarkdown from '@resources/js/components/EnhancedMarkdown/EnhancedMarkdown';
import { SelectListItem } from '@resources/js/typings/viewModels/selectListItemViewModel';
import VerticalContent from '@resources/js/components/VerticalContent/VerticalContent';
import TabbedSelect from '@resources/js/components/TabbedSelect/TabbedSelect';
import { TabbedSelectLinkOptionWrapperProps } from '../../../../archon/components/TabbedSelectLinkOptionWrapper/TabbedSelectLinkOptionWrapper';
import Link from 'next/link';

export type BuildsRotationIntroSectionViewModel = {
  title: string;
  description: string;
  encounterOptions: SelectListItem<string>[];
};

export default function BuildsRotationIntroSection({
  title,
  description,
  encounterOptions,
}: BuildsRotationIntroSectionViewModel): JSX.Element | null {
  if (!title) {
    return null;
  }

  return (
    <div className='builds-rotation-intro-section'>
      <VerticalContent gap={'small'}>
        <EnhancedMarkdown
          markdown={`
# ${title}

${description}
`}
          overrides={buildsEnhancedMarkdownOverrides}
        />
        <div style={{ display: 'flex' }}>
          <TabbedSelect
            className={'builds-rotation-intro-section__encounter-select'}
            style={'v2'}
            isVertical
            value={null}
            options={encounterOptions}
            OptionWrapper={OptionWrapper}
            wrapperInheritsProps
          />
        </div>
      </VerticalContent>
    </div>
  );
}

function OptionWrapper({
  option,
  ...rest
}: TabbedSelectLinkOptionWrapperProps): JSX.Element {
  if (option.url) {
    return (
      <Link {...rest} href={option.url} scroll={false} prefetch={false}>
        <EnhancedMarkdown markdown={option.label} />
      </Link>
    );
  }

  return <EnhancedMarkdown markdown={option.label} />;
}
